import { isBuilderMode } from './builderMode'

const DEFAULT_PREFIX = 'previo_'

/**
 * Prefix of the application's localStorage keys (`previo_<key>`).
 *
 * Only `vite --mode builder` serves every app under a path prefix on one shared origin (the
 * `@previo/builder` proxy), where PMS, CRM, ID and Agency would otherwise overwrite each other's
 * keys; there the prefix carries the base segment too (`previo_pms_`).
 *
 * The condition is on the mode, not on `BASE_URL`, on purpose: a future change of the production
 * `base` (sub path, CDN) must never rename the keys and log every user out.
 */
export const localStorageKeyPrefix = (): string => {
  if (!isBuilderMode()) {
    return DEFAULT_PREFIX
  }

  const baseSegment = import.meta.env.BASE_URL.replace(/\//g, '')

  return baseSegment ? `${DEFAULT_PREFIX}${baseSegment}_` : DEFAULT_PREFIX
}
